/**
 * Lenient phone/fax pattern for form input validation. Mirrors what the backend
 * accepts before normalization: an optional single leading "+" followed by any
 * mix of digits and common separators (spaces, "-", "/"), and must contain at
 * least one digit. Purely textual input (no digits) is rejected.
 */
export const PHONE_REGEX = /^\+?[\d\s/-]*\d[\d\s/-]*$/;
